import { SandboxComponent } from "./sandbox/sandbox.component";

export { SandboxComponent } from "./sandbox/sandbox.component";

export const Pages = [
	SandboxComponent
]
